import i18n from '@/utils/i18n';
import PhoneIcon from '@assets/icons/phone.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { OperatorEmployeeContact } from '@/types';
import { TouchableOpacity } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

const ICON_SIZE = 16;

interface Props {
  contacts?: OperatorEmployeeContact[];
  itemCountDisplay?: string;
  onPress: () => void;
  orderAmount?: string;
}

export const OrderAction: React.FC<Props> = ({
  contacts,
  itemCountDisplay,
  onPress,
  orderAmount,
}) => {
  const [styles, theme] = useStyles();

  // if there are contacts, show the phone icon
  if (contacts && contacts.length > 0) {
    return (
      <TouchableOpacity
        accessibilityLabel={i18n.t('insights_hub.current_orders_section.call')}
        onPress={onPress}
        style={styles.actionsElement}
      >
        <PhoneIcon stroke={theme.sk.color.icon.primary} width={ICON_SIZE} />
      </TouchableOpacity>
    );
  }

  return (
    <>
      {orderAmount ? (
        <Typography
          color={theme.sk.color.text.primary}
          variant="paragraph-base"
        >
          {orderAmount}
        </Typography>
      ) : null}

      {itemCountDisplay ? (
        <Typography color={theme.sk.color.text.tertiary} variant="paragraph-md">
          {itemCountDisplay}
        </Typography>
      ) : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  actionsElement: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.tertiary.default,
    borderRadius: 20,
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
}));
